import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ErrorMessage } from '@hookform/error-message';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: any) => ({
  error: {
    color: theme.palette.error.main,
    marginTop: theme.spacing(0.5),
  },
}));

export interface FormErrorProps {
  name: string;
  errors: Record<string, unknown>;
}

export default function FieldError({ errors = {}, name }: FormErrorProps) {
  const classes = useStyles();

  return (
    <ErrorMessage
      errors={errors}
      name={name}
      render={({ message }) => (
        <Typography variant="body2" gutterBottom className={classes.error}>
          {message}
        </Typography>
      )}
    />
  );
}
